import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from '../../config/i18n';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import MetadataTable from '../../components/metadata/MetadataTable';

class MetadataContainer extends Component {
  static propTypes = {
    metadata: PropTypes.shape({
      isLoading: PropTypes.bool,
    }).isRequired,
    actions: PropTypes.shape({
      getMetadata: PropTypes.func.isRequired,
    }).isRequired,
  };
  static defaultProps = {};

  componentDidMount() {
    this.props.actions.getMetadata();
  }

  render() {
    const {
      metadata: {
        data,
        type,
        isLoading,
      },
      actions,
    } = this.props;
    const metadataSections = [];

    if (!_.isEmpty(data)) {
      // Filter out string type names
      const typeNames = _.values(type).filter(typeName => typeof (typeName) === 'string');
      typeNames.forEach((typeName) => {
        metadataSections.push((
          <div key={typeName}>
            <h2>
              {i18n.t(typeName)}
            </h2>
            <MetadataTable
              metadataList={data[typeName] || {}}
              metadataTypeId={type[typeName]}
              actions={actions}
              metadataKey={typeName}
              isLoading={isLoading}
            />
            <hr />
          </div>
        ));
      });
    }

    return (
      <div>
        <h1>
          {i18n.t('manageMetadata')}
        </h1>
        <p className="lead">
          {i18n.t('chooseMetadataToEdit')}
        </p>
        <hr />
        {metadataSections}
      </div>
    );
  }
}

export default connectActionsAndReducers(MetadataContainer);



// WEBPACK FOOTER //
// ./src/containers/metadata/MetadataContainer.js